import HiddenNav from '../../classes/HiddenNav';

const isFixed = ( header, staticElement ) => {
	const isHeaderShown = !header.classList.contains( 'scroll-down' );
	let {top} = staticElement.getBoundingClientRect();
	if ( isHeaderShown )
	{
		top -= header.offsetHeight;
	}

	return top < 0;
};


export const initNav = () => {
	const nav = document.querySelector( 'section.cds2-complex-menu nav' );
	
	if ( !nav )
	{
		return;
	}
	
	document.body.classList.add( 'with-submenu' );
	
	const header = document.querySelector('header');
	const menu = nav.querySelector( 'ul.menu' );
	const productMenu = nav.querySelector( 'ul.product' );
	
	if ( !menu || !productMenu )
	{
		return;
	}

	const setMaxMenuContainerWidth = () => {
		if ( window.innerWidth >= 1024 )
		{
			const navStyles = window.getComputedStyle( nav );
			let maxMenuWidth = 0;
		
			maxMenuWidth += ( nav.offsetWidth - parseFloat( navStyles.paddingLeft ) - parseFloat( navStyles.paddingRight ) ) - productMenu.offsetWidth;
			
			menu.style.setProperty( 'max-width', `${maxMenuWidth}px` );
		}
		else
		{
			menu.style.removeProperty( 'max-width' );
		}
	};

	window.addEventListener( 'resize', setMaxMenuContainerWidth );

	setMaxMenuContainerWidth();

	const hiddenNavInstance = new HiddenNav( menu );

	hiddenNavInstance.init( window.innerWidth >= 1024 );

	const handleResize = () => {
		if ( window.innerWidth >= 1024 && !hiddenNavInstance.isHiding() )
		{
			hiddenNavInstance.startHiding();
		}
	
		if ( window.innerWidth < 1024 && hiddenNavInstance.isHiding() )
		{
			hiddenNavInstance.stopHiding();
		}
	};

	window.addEventListener( 'resize', handleResize );

	if ( document.body.classList.contains( 'visual' ) )
	{
		return;
	}

	window.addEventListener( 'scroll', () => isFixed(header, nav.parentElement) ? nav.classList.add( 'fixed' ) : nav.classList.remove( 'fixed' ));
};
